module.exports = __webpack_public_path__ + "media/images/team/jack_crowley-bff67053f3120868ab0df9db9de4d100.png";